module.exports = __webpack_public_path__ + "static/media/Nigeria.c5435945.png";